import type { PaymentMethod } from '../../services/commonCheckout/types/PaymentMethod';

export const getMedicationValue = (
  paymentMethod: PaymentMethod<'CARD'>,
): string => {
  const { cardCategories } = paymentMethod.paymentMethodDetails;
  const firstCategory = cardCategories?.[0];
  const { label = '' } = firstCategory?.medications?.[0] || {};

  return label;
};
